import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalvosSalesCommissionLimitManagementView } from "src/tenantCustomizations/tenants/salvos/sales/salesCommissions/SalvosSalesCommissionLimitManagementView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/salvos/salesCommissionLimits")({
	staticData: { title: i18n.t("commission_limits"), legacyViewKey: "salvosSalesCommissionLimitManagementPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalvosSalesCommissionLimitManagementView />;
}
